import { pickBy, identity } from 'lodash';
import { httpV1 as http } from '@/services/api';

/** Comissão diferenciada de ativação/reativação de parceiros (Wow Moment), B2B-206 / B2B-306. */

export async function list(params = {}) {
  const {
    promoter_id, rate_id, product_id, supplier_id, status, rate_name,
    promoter_search, starts_from, starts_to,
    page, per_page,
  } = params;

  const { data } = await http.get('/promoter-commission-promotions', {
    params: pickBy({
      promoter_id,
      rate_id,
      product_id,
      supplier_id,
      status,
      rate_name,
      promoter_search,
      starts_from,
      starts_to,
      page,
      per_page,
    }, identity),
  });

  return data;
}

export async function show(id) {
  return http.get(`/promoter-commission-promotions/${id}`);
}
